const s = {
  name: "Hands01110",
  dimensions: { width: 26, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 40" style="enable-background:new 0 0 26 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13.8,2.7C13.2,1.1,11.7,0,10,0C8.3,0,6.8,1.1,6.2,2.7C5.6,2.2,4.8,2,4,2C1.8,2,0,3.8,0,6v21
			c0,7.2,5.8,13,13,13c7.2,0,13-5.8,13-13v-9c0-2.2-1.8-4-4-4c-0.7,0-1.4,0.2-2,0.5V6c0-2.2-1.8-4-4-4C15.2,2,14.4,2.2,13.8,2.7z
			 M10,2c1.1,0,2,0.9,2,2v15.5c-0.6-0.3-1.3-0.5-2-0.5H8V4C8,2.9,8.9,2,10,2z M24,21c0,1.1-0.9,2-2,2s-2-0.9-2-2v-3c0-1.1,0.9-2,2-2
			s2,0.9,2,2V21z M18,21h-4V6c0-1.1,0.9-2,2-2s2,0.9,2,2V21z M18.5,23c0.7,1.2,2,2,3.5,2c0.7,0,1.4-0.2,2-0.5V27c0,6.1-4.9,11-11,11
			C6.9,38,2,33.1,2,27v-4c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2s-0.9,2-2,2H6v2h4c2.2,0,4-1.8,4-4H18.5z M4,4c1.1,0,2,0.9,2,2v13H4
			c-0.7,0-1.4,0.2-2,0.5V6C2,4.9,2.9,4,4,4z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Hands01110
};
